module.exports = __webpack_public_path__ + "img/ring_r_o_1_null@3x.144d0567.png";